import ReceiptBreakdownReport from './ReceiptBreakdownReport';

export default function ReceiptsOwnersReport() {
  return <ReceiptBreakdownReport type="PROPIETARIO" />;
}
